export default __webpack_public_path__ + "static/media/filter_category_light.e94f0315.svg";